<template>
  <div>
    <Row style="margin-bottom: 14px;">
      <Col span="4" style="padding-right:10px">
        <Input
          v-model="alertRuleSearchKey"
          :placeholder="$t('alarms.common.filterByAlertRuleName')"
        />
      </Col>
      <Col span="4">
        <Button
          type="primary"
          v-hasPermission="['monitor:complianceChecks:page']"
          @click="getData"
          >{{ $t("message.select") }}</Button
        >
      </Col>
    </Row>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="complianceChecksListData"
      style="width: 100.1%;"
    >
      <template slot-scope="{ row, index }" slot="detail">
        <Button
          type="info"
          size="small"
          v-hasPermission="[
            'monitor:complianceChecks:queryConfigRuleCheckItemsDetail'
          ]"
          @click="complianceChecksListDetail(row)"
          >{{ $t("alarms.complianceChecks.Details") }}</Button
        >
      </template>
    </Table>
  </div>
</template>

<script>
var complianceChecksListVue = {};
export default {
  name: "ComplianceChecksList",
  data() {
    return {
      alertRuleSearchKey: "",
      columns: [
        {
          title: this.$t("alarms.complianceChecks.RuleName"),
          key: "configRuleName"
        },
        {
          title: this.$t("alarms.complianceChecks.Compliance"),
          key: "compliance"
        },
        {
          title: this.$t("alarms.complianceChecks.Area"),
          key: "region"
        },
        {
          title: this.$t("alarms.complianceChecks.Description"),
          key: "description"
        },
        {
          title: this.$t("alarms.complianceChecks.Operating"),
          slot: "detail"
        }
      ],
      complianceChecksListData: []
    };
  },
  beforeCreate: function() {
    complianceChecksListVue = this;
  },
  mounted() {},
  methods: {
    getData() {
      complianceChecksListVue.queryConfigRuleCheckItemsTable();
    },
    queryConfigRuleCheckItemsTable: function() {
      this.$api.awsConfigCheckItem
        .queryConfigRuleCheckItemsTable({
          configRuleName: this.alertRuleSearchKey
        })
        .then(res => {
          this.complianceChecksListData = res.data;
        });
    },
    // 详情
    complianceChecksListDetail: function(row) {
      this.$router.push({
        path: "/monitor/complianceChecksDetail/",
        query: {
          accountId: row.accountId,
          region: row.region,
          configRuleName: row.configRuleName
        }
      });
    },
    // 按规则名称搜索
    searchAlertRule: function() {}
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/monitor/compliance_checks/complianceChecks_list/ComplianceChecksList.vue